import { CancelTokenSource } from "axios";
import {
  InterventionAvailabilityDetailsDto,
  InterventionAvailabilityForDateRequest,
  InterventionAvailabilitySlotSearchDto,
  InterventionDto,
  InterventionSlotDto,
  UpsertInterventionAvailabilityDto
} from "ts-types/api.types";
import axios from "./http";

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/intervention-availability`;

export const getInterventionAvailability = (
    id: number, source: CancelTokenSource)
    : Promise<InterventionAvailabilityDetailsDto> => {

  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const getAllSlotsByAvailabilityId = (
    availabilityId: number, source: CancelTokenSource)
    : Promise<Array<InterventionSlotDto>> => {
  return axios
      .get(`${apiUri}/intervention-slots`,{
        params: {availabilityId: availabilityId}, cancelToken: source.token})
      .then(response => response.data)
};

export const getAvailableDates = (
    request: InterventionAvailabilityForDateRequest,
    source: CancelTokenSource)
    : Promise<string[]> => {

  return axios
      .post(`${apiUri}/available-dates`, request, {cancelToken: source.token})
      .then(response => response.data);
};

export const getInterventionAvailabilitiesForDay = (
    request: InterventionAvailabilityForDateRequest,
    day: string,
    source: CancelTokenSource)
    : Promise<InterventionAvailabilitySlotSearchDto[]> => {

  return axios
      .post(`${apiUri}/slots`, request, {params: {day: day}, cancelToken: source.token})
      .then(response => response.data);
};

export const addInterventionAvailability = (
    upsertInterventionAvailabilityDto: Partial<UpsertInterventionAvailabilityDto>,
    source: CancelTokenSource)
    : Promise<InterventionDto> => {

  return axios
      .post(apiUri, upsertInterventionAvailabilityDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editInterventionAvailability = (
    id: number,
    upsertInterventionAvailabilityDto: Partial<UpsertInterventionAvailabilityDto>,
    source: CancelTokenSource)
    : Promise<string> => {

  return axios
      .put(`${apiUri}/${id}`, upsertInterventionAvailabilityDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteInterventionAvailability = (
    id: number, source: CancelTokenSource)
    : Promise<number> => {

  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};
